import { Component, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';

@Component({
  selector: 'app-zoho-sync',
  templateUrl: './zoho-sync.component.html',
  styleUrls: ['./zoho-sync.component.scss'],
})
export class ZohoSyncComponent implements OnInit {
  syncButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    size: ButtonSize.BIG,
    text: 'Enable Sync',
    route: ['/accounts', 'zoho_sync'],
  };

  constructor() {}

  ngOnInit() {}
}
